import Main from '../layout/main/main';
import styles from './timeline.module.css';


const Timeline = (props) => {
  return (
    <Main h="Timeline" activeIndex="0" className="sm5-active-section">
        <img
          src="https://bucket.zhiyun-tech.com/detail/sm5challenge-timeline.svg"
          alt=""
          className={`${styles.img} sm5-active-desktop sm5-active-fade-in-element`}
        />
                <img
          src="https://bucket.zhiyun-tech.com/detail/sm5challenge-timeline-mobile.svg"
          alt=""
          className={`${styles.img} sm5-active-mobile sm5-active-fade-in-element`}
        />
    </Main>
  );
};

export default Timeline;
